// Aesthetics score over a plain Pog. The spine is INFERRED from the plan (a base pog carries no contract) and attribute roles resolve positionally, so no pog column is named here; only the laundry VALUE rules are handed in.
import { Pog } from "@CommonTypes/merchflow/pog/pog";
import { POG_PREFERRED_ORDER, pogToStudioItems } from "../adapters/pogToStudioItems";
import { detectExceptions } from "../resolver/detectExceptions";
import type { AestheticsRules } from "./aestheticsRules";
import { draftFromInference, inferSpine } from "./spineInference";
import { scorePlanogramAesthetics, type AestheticsScore } from "./aestheticsScore";

export const pogAestheticsScore = (
  pog: Pog | null,
  rules: Partial<AestheticsRules> = {},
): AestheticsScore | null => {
  if (!pog) return null;
  try {
    const { items, runs, candidates } = pogToStudioItems([pog]);
    if (!items.length || !runs.length) return null;
    const draft = draftFromInference(
      inferSpine(items, candidates, runs, { preferredOrder: POG_PREFERRED_ORDER }),
    );
    // Unranged items are ranged SKUs the plan did not place.
    const rangedSkuIds = [
      ...items.map((item) => item.skuId),
      ...pog.unrangedItems.map((item) => item.productCode || item.id),
    ];
    return scorePlanogramAesthetics({
      items,
      runs,
      draft,
      flags: detectExceptions(items, runs, draft, {
        quantityAttribute: rules.sizeAttr,
        blockIdentityAttributes: rules.verticalAttrs,
      }).flags,
      rules,
      rangedSkuIds,
    });
  } catch {
    // A metric never breaks a page: an unreadable pog reports nothing.
    return null;
  }
};
